// src/views/auth/index.js
import Auth from "./Auth";

export default Auth;
